import { Injectable } from '@angular/core';
import moment from 'moment';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter, from, map } from "rxjs";
import { UtilityService } from '../../../../../air/modules/common/service/utility/utility.service';
import { HttpClient, HttpParams } from "@angular/common/http";
import { UserEndPoint, AirAppRoutes, AdminEndPoint } from "../../../../../air/modules/common/lib/air-api-constant";
import { StorageService } from "../../../../../air/modules/common/service/storage/storage.service";
import { EConfig } from "../../../../../air/modules/common/lib/model/common";
import * as settings from "../../lib/air-api-constant";
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private rowData: any;
  private readonly rowDataKey = 'rowData';
  private setting = {
    element: {
      dynamicDownload: null as unknown as HTMLElement
    }
  }

  private sameRouteReloadPromise = new BehaviorSubject<boolean>(false);
  public $sameRouteReload = this.sameRouteReloadPromise.asObservable();
  private showAirDisplaySubject = new BehaviorSubject<boolean>(true);
  public showAirDisplay$ = this.showAirDisplaySubject.asObservable();

  constructor(
    protected http: HttpClient,
    protected utilityService: UtilityService,
    private storageService: StorageService,
    protected router: Router,
  ) {
    const rowDataString = localStorage.getItem(this.rowDataKey);
    this.rowData = rowDataString ? JSON.parse(rowDataString) : null;
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.updateDisplayMode(event.url);
      }
    });
  }

  public updateDisplayMode(url: string) {
    const showAir = url.includes('/air');
    this.showAirDisplaySubject.next(showAir);
  }

  public setRowData(rowData: any) {
    this.rowData = rowData;
    localStorage.setItem(this.rowDataKey, JSON.stringify(rowData));
  }

  public getRowData() {
    return this.rowData;
  }

  public clearRowData() {
    this.rowData = null;
    localStorage.removeItem(this.rowDataKey);
  }

  public updateSameRouteNavigation(value:any) {
    this.sameRouteReloadPromise.next(value);
  }

  public removeFromArray(elem: any = {}, records: Array<any> = []) {
    const index = records.indexOf(elem);
    if (index > -1) {
      records.splice(index, 1);
    }
  }

  public pointsToPath(from :any, to: any, invertArc = true) {
    var arcPointX = (from.x + to.x) / (invertArc ? 2.4 : 1.6),
      arcPointY = (from.y + to.y) / (invertArc ? 2.4 : 1.6);
    if (!invertArc) {
      return 'M' + from.x + ',' + from.y + ',' + to.x + ' ' + to.y;
    } else {
      return 'M' + from.x + ',' + from.y + 'Q' + arcPointX + ' ' + arcPointY +
        ',' + to.x + ' ' + to.y;
    }

  }

  //#region TNT common service

  getCompanyDetails(emailId: string) {
    let params = new HttpParams();
    params = params.append("userId", emailId);
    return this.http.get(UserEndPoint.UserPortal.GET_COMPANY_ASSOCIATED, {params});
  }

  getAirCompany() {
    return this.http.get(settings.UserEndPoint.UserPortal.GET_COMPANY_ASSOCIATED);
  }

  getRegion(body: any = {}) {
    return this.http.post(UserEndPoint.AirFilters.ORIGIN_DESTINATION_REGION, body).pipe(
      filter(data => !!data), 
      map((response: any) => {
        let originRegions: Array<any> = [];
        if(response && response.data){
          response.data.map((region: any) => {           
            originRegions.push( { label: region.id, value: region.value } );
          });
        }
        return originRegions;
      })
    )
  }

  getBDPRepresentatives(body: any = {}) {
    return this.http.post(UserEndPoint.AirFilters.BDP_REPRESENTATIVES, body).pipe(
      filter(data => !!data),
      map((response: any) => {
        let bdpRepresentatives:Array<any> = [];
        if (response && response.data) {
          response.data.map((representative: any) => {
            bdpRepresentatives.push({ id: representative.id, value: representative.value });
          });
        }
        return bdpRepresentatives;
      })
    )
  }

  getBdpSBUs(body: any = {}) {
    return this.http.post(UserEndPoint.AirFilters.BDP_SBUS, body).pipe(
      filter(data => !!data),
      map((response: any) => {
        let sbus: Array<any> = [];
        if (response && response.data) {
          response.data.map((sbu: any) => {
            sbus.push({ id: sbu.id, value: sbu.value });
          });
        }
        return sbus;
      })
    );
  }

  getBdpServiceCode(body: any = {}) {
    return this.http.post(UserEndPoint.AirFilters.SERVICE_CODES, body);
  }

  getBdpCarriers(body: any = {}) {
    return this.http.post(UserEndPoint.AirFilters.CARRIER_NAMES, body).pipe(
      filter(data => !!data),
      map((response: any) => {
        let carriers: Array<any> = [];
        if (response && response.data) {
          response.data.map((carrier: any) => {
            carriers.push({ id: carrier.id, value: carrier.value });
          });
        }
        return carriers;
      })
    );
  }

  getFlights(body: any = {}) {
    return this.http.post(UserEndPoint.AirFilters.FLIGHTS, body).pipe(
      filter(data => !!data),
      map((response: any) => {
        let flights: Array<any> = [];
        if (response && response.data) {
          response.data.map((flight: any) => {
            flights.push({ id: flight.id, value: flight.value });
          });
        }
        return flights;
      })
    );;
  }

  getPlaceofReceipt(body: any = {}) {
    return this.http.post(UserEndPoint.AirFilters.PLACE_OF_RECEIPT, body).pipe(
      filter(data => !!data),
      map((response: any) => {
        let placeOfReceipt: Array<any> = [];
        if (response && response.data) {
          response.data.map((receipt: any) => {
            placeOfReceipt.push({ id: receipt.id, value: receipt.value});
          });
        }
        return placeOfReceipt;
      })
    )
  }

  getPlaceOfDelivery(body: any = {}) {
    return this.http.post(UserEndPoint.AirFilters.PLACE_OF_DELIVERY, body).pipe(
      filter(data => !!data),
      map((response: any) => {
        let placeOfDelivery: Array<any> = [];
        if (response && response.data) {
          response.data.map((delivery: any) => {
            placeOfDelivery.push({ id: delivery.id, value: delivery.value});
          });
        }
        return placeOfDelivery;
      })
    )
  }

  getportsLocations() {
    // return locations;
  }

  getPOA(body: any = {}) {
    return this.http.post<any>(UserEndPoint.AirFilters.PORT_OF_ARRIVAL, body).pipe(
      filter(data => !!data),
      map((response: any) => {
        let portOfArrivals: Array<any> = [];
        if (response && response.data) {
          response.data.map((poa: any) => {
            portOfArrivals.push({ id: poa.id, value: poa.value});
          });
        }
        return portOfArrivals;
      })
    );
  }

  getPOD(body: any = {}) {
    return this.http.post<any>(UserEndPoint.AirFilters.PORT_OF_DEPATURE, body).pipe(
      filter(data => !!data),
      map((response: any) => {
        let portOfDepartures: Array<any> = [];
        if (response && response.data) {
          response.data.map((pod: any) => {
            portOfDepartures.push({ id: pod.id, value: pod.value});
          });
        }
        return portOfDepartures;
      })
    );
  }




  getMasterEvents() {
    return this.http.get<any>(UserEndPoint.CommonService.MASTER_EVENTS)
  }


  //#endregion TNT common service

  formatDate(date:any, format: boolean = false) {
    let input = moment(date, 'YYYY-MM-DD')
    if (input.isValid()) {
      if (format) {
        return moment(date, 'YYYY-MM-DD').format('DD MMM YYYY')
      } else {
        return input.toDate();
      }
    }
    return date;
  }
  formatDate1(date: string, format: boolean = false): string | Date {
    let input = moment(date, moment.ISO_8601, true); 
    if (input.isValid()) {
        if (format) {
            return input.format('DD MMM YYYY');
        } else {
            return input.toDate();
        }
    }
    return date;
}


  formatDateWithTime(date:any) {
    let input = moment(date, 'YYYY-MM-DD')
    if (input.isValid()) {
      return moment(date, 'YYYY-MM-DD').format('DD MMM YYYY HH:mm')
    }
    return date;
  }

  formatDateWithTimeForLastSentOn(date: moment.MomentInput) {
    let input = moment(date)
    if (input.isValid()) {
      return moment(date).format('DD MMM YYYY HH:mm:ss')
    }
    return date;
  }

  formatDateForReprocessing(date: moment.MomentInput) {
    let input = moment(date, 'YYYY-MM-DD HH:mm:ss')
    if (input.isValid()) {
      return input.toDate();
    }
    return date;
  }

  formatDateforInput(date: moment.MomentInput) {
    let input = moment(date, 'YYYY-MM-DD')
    if (input.isValid()) {
      return moment(date).format('YYYY-MM-DDTHH:mm:ss')
    }
    return date;
  }

  formatExceptionDateWithTime(date: moment.MomentInput) {
    let input = moment(date, 'YYYY-MM-DD')
    if (input.isValid()) {
      return moment(date, 'YYYY-MM-DD').format('DD MMM YYYY')
    }
    return date;
  }

  formatDateWithTimeForDocument(date: moment.MomentInput) {
    let input = moment(date, 'YYYY-MM-DD')
    if (input.isValid()) {
      return moment(date, 'YYYY-MM-DD').format('DD MMM YYYY')
    }
    return date;
  }

  formatDateWithTimeForDocumentDistribution(date: moment.MomentInput) {
    let input = moment(date, 'YYYY-MM-DDTHH:mm:ss')
    if (input.isValid()) {
      return input.format('DD MMM YYYY')
      // return input.format('DD MMM YYYY | HH:mm')
    }
    return date;
  }

  getCurrentDate() {
    return moment().format('YYYY-MM-DD');
  }

  getCurrentDateTime() {
    return moment().utc().format('YYYY-MM-DD');
  }

  getMonthDifferenceWithTime(numberOfMonths: number) {
    return moment().utc().subtract(numberOfMonths, 'months').format('YYYY-MM-DD');
  }

  getDateAfterDays(days: number) {
    return moment().utc().subtract(days, 'days').format('YYYY-MM-DD');
  }


  getMonthDifference(numberOfMonths: moment.DurationInputArg1) {
    return moment().subtract(numberOfMonths, 'months').format('YYYY-MM-DD')
  }

  getWeekDifference(numberOfMonths: moment.DurationInputArg1) {
    return moment().subtract(numberOfMonths, 'weeks').format('YYYY-MM-DD')
  }

  capitalize(text: string) {
    if (text) {
      return text.trim().split(" ").map((splitVal: string) => {
        splitVal = splitVal.trim();
        if (splitVal.indexOf("(") >= 0 || splitVal.indexOf("[") >= 0 || splitVal.indexOf("{") >= 0) {
          return splitVal;
        } else {
          splitVal = splitVal.toLowerCase();
          splitVal = (splitVal.charAt(0) + "").toUpperCase() + splitVal.substr(1, splitVal.length);
          return splitVal;
        }
      }).join(" ");
    } else {
      return text;
    }
  }

  getConfig(body: any): any {
    return from(new Promise((resolve: any, reject: any) => {
      let params = new HttpParams();
      params = params.append("configType", body);
      this.http.get(AdminEndPoint.CustomerManagement.GET_CUSTOMER_CONFIG, { params }).subscribe((response: any) => {
        let configs: any = {};
        if (response) {
          response.map((config: any) => {
            if (configs[config.configType]) {
              configs[config.configType].push(config);
            } else {
              configs[config.configType] = [config];
            }
          })
          const groupNames: Array<any> = [];
          const groupCodes: Array<any> = [];
          const modes: Array<any> = [];
          const salesTerms: Array<any> = [];
          const events: Array<any> = [];
          const portNames: Array<any> = [];
          const portLocations: Array<any> = [];
          const companyList: any = {};
          const vessels: Array<any> = [];


          const tempLocations: any = location;
          tempLocations.map((location: { code: string; name: string; }) => {
            portNames.push({ label: location.code, value: location.code });
            portLocations.push({ label: location.name + " " + "(" + location.code + ")", value: location.code });
          });

          if (configs[EConfig.GROUP]) {
            configs[EConfig.GROUP].map((group: any) => {
              groupNames.push({
                label: group.name,
                value: group.name,
              });
              groupCodes.push({
                label: group.code,
                value: group.code,
              });
              companyList[group.code] = group.name;
            })
          }

          if (configs[EConfig.MODE]) {
            configs[EConfig.MODE].map((group: any) => {
              modes.push({
                label: group.name,
                value: group.name,
              });
            })
          }

          if (configs[EConfig.SALES_TERM]) {
            configs[EConfig.SALES_TERM].map((salesTerm: any) => {
              salesTerms.push({
                label: salesTerm.name,
                value: salesTerm.code,
                details: salesTerm.configType
              });
            })
          }



          if (configs[EConfig.MASTER_EVENTS]) {
            configs[EConfig.MASTER_EVENTS].map((event: any) => {
              events.push({
                label: event.name,
                value: event.code.toLowerCase(),
              });
            })
            events
          }

          if (configs[EConfig.VESSEL]) {
            configs[EConfig.VESSEL].map((vessel: any) => {
              vessels.push({ label: vessel.name, value: vessel.code });
            });
          }
          configs = {
            vessels,
            portLocations,
            portNames,
            salesTerms,
            modes,
            groupCodes,
            groupNames,
            events
          }
        }
        resolve(configs);
      }, (error: any) => {
        reject(error);
      })
    }));
  }

  public parseJwt(token: string) {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  };

  public navigateRoute(settings: any = {}) {
    let rootPath: string = '/';
    if (settings.type == 'User') {
      rootPath = rootPath + AirAppRoutes.User.ROOT;
    }
    if (settings.type == 'Manager') {
      rootPath = rootPath + AirAppRoutes.Manager.ROOT;
    }
    if (settings.type) {
      rootPath = rootPath + "/" + settings.route;
    } else {
      rootPath = rootPath + settings.route;
    }

    if (settings.routeData) {
      if (settings.routeData.encryptedText) {
        this.router.navigate([rootPath, settings.routeData.shipmentId, settings.routeData.encryptedText])
      }
      else {
        this.router.navigate([rootPath, settings.routeData]);
      }
    }
    else {
      this.router.navigateByUrl(rootPath);
    }
  }

  getUser() {
    return this.storageService.getItem('email');
  }

  public getRoute(settings: any = {}) {
    let rootPath: string = '/';
    if (settings.type == 'User') {
      rootPath = rootPath + AirAppRoutes.User.ROOT;
    }
    if (settings.type == 'Manager') {
      rootPath = rootPath + AirAppRoutes.Manager.ROOT;
    }
    if (settings.type) {
      rootPath = rootPath + "/" + settings.route;
    } else {
      rootPath = rootPath + settings.route;
    }
    return rootPath;
  }

  getCustomerUserManual() {
    let queryParams = new HttpParams();
    queryParams = queryParams.append("docType", 'Help')
    return this.http.get(UserEndPoint.CommonService.DOWNLOAD_USER_MANUAL, { params: queryParams });
  }

  isTrackingListDetailsRoute(route: string) {
    return route.includes(AirAppRoutes.User.TRACKING_LIST_DETAILS) ||
      route.includes(AirAppRoutes.User.TRACKING_LIST_DETAILS_HOME) ||
      route.includes(AirAppRoutes.User.TRACKING_LIST_DETAILS_FAVORITE)
  }

  getSortedArray(array: any[], field: string = 'name') {
    return array.sort((a: { [x: string]: number; }, b: { [x: string]: number; }) => (a[field] > b[field]) ? 1 : ((b[field] > a[field]) ? -1 : 0))
  }

  autoComplete(jsonArray: any[], filterText: string): any[] {
    let filteredArray: Array<any> = []
    filteredArray = jsonArray.filter((item: { name: string; }) => item.name.toLowerCase().includes(filterText.toLowerCase()));
    return this.getSortedArray(filteredArray);
  }
  autoCompleteLocation(jsonArray: any[], filterText: string): any[] {
    let filteredArray: Array<any> = []
    filteredArray = jsonArray.filter((item: { name: string; code: string; }) => item.name.toLowerCase().includes(filterText.toLowerCase()) || item.code.toLowerCase().includes(filterText.toLowerCase()));
    return this.getSortedArray(filteredArray);
  }
  autoCompleteLocationWithCode(jsonArray: any[], filterText: string): any[] {
    let filteredArray: Array<any> = [];
    filteredArray = jsonArray.filter((item: { name: string; code: string; }) => item.name.toLowerCase().includes(filterText.toLowerCase()) || item.code.toLowerCase().includes(filterText.toLowerCase()));
    filteredArray = filteredArray.map((item: { name: string; code: string; }) => {
      item.name = item.name + ' (' + item.code + ')';
      return item;
    })
    return this.getSortedArray(filteredArray);
  }
  autoCompleteFilters(jsonArray: any[], filterText: string): any[] {
    let filteredArray: Array<any> = []
    filteredArray = jsonArray.filter((item: { value: string; }) => item.value.toLowerCase().includes(filterText.toLowerCase()));
    return this.getSortedArray(filteredArray, 'value');
  }
  downloadAsJsonFile(arg: {
    fileName: string,
    text: string
  }) {
    if (!this.setting.element.dynamicDownload) {
      this.setting.element.dynamicDownload = document.createElement('a');
    }
    const element = this.setting.element.dynamicDownload;
    const fileType = arg.fileName.indexOf('.json') > -1 ? 'text/json' : 'text/plain';
    element.setAttribute('href', `data:${fileType};charset=utf-8,${encodeURIComponent(arg.text)}`);
    element.setAttribute('download', arg.fileName);

    var event = new MouseEvent("click");
    element.dispatchEvent(event);
  }
  // Sorts array of objects(array) using another array(order) on a particular field(key) 
  mapOrder(array: any[], order: string | any[], key: string) {

    array.sort(function (a: { [x: string]: any; }, b: { [x: string]: any; }) {
      var A = a[key], B = b[key];

      if (order.indexOf(A) > order.indexOf(B)) {
        return 1;
      } else {
        return -1;
      }

    });

    return array;
  };

  getDocumentType(shipmentId: any) {
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    return this.http.get(UserEndPoint.smartDocuments.DOCUMENT_TYPES, { params: params });
  }

  getDocumentDistributionList(shipmentId: any) {
    let params = new HttpParams();
    params = params.append("shipmentId", shipmentId);
    return this.http.get(UserEndPoint.smartDocuments.DOCUMENT_DISTRIBUTION_LIST, { params: params });
  }
  extractFilename(contentDisposition: string | null): string | null {
    if (!contentDisposition) {
      return null;
    }

    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    return match && match[1] ? match[1] : null;
  }

  downLoadFile(data:any, fileName:any) {
    const anchorElement = document.createElement('a');
    document.body.appendChild(anchorElement);
    anchorElement.style.display = 'none';
    const json = JSON.stringify(data);
    const blob = new Blob([json], { type: 'application/octet-stream', });
    const url = window.URL.createObjectURL(blob);
    anchorElement.href = url; anchorElement.download = fileName; anchorElement.click();
    window.URL.revokeObjectURL(url);
  }

  displayPdf(pdfData: ArrayBuffer, filename: string): void {
    const blob = new Blob([pdfData], { type: 'application/pdf' });
    const pdfUrl = URL.createObjectURL(blob);
    const newWindow = window.open(pdfUrl, '_blank');
    if (newWindow) {
      newWindow.document.title = filename;
    }
  }


   //#region  Get all Time Zone in Event Manager
   getAllTimeZone(iataCode: string): any {
    const url = `${settings.UserEndPoint.AirEventManagement.GET_TIME_ZONE}`;
    let params = new HttpParams();
    params = params.append('iata_code', iataCode);
    
    return this.http.get(url, { params });
}
  //#endregion

  //#region  Get all event in Event Manager
  getAllMasterEvent(): any {
    const url = `${settings.UserEndPoint.AirEventManagement.GET_ALL_EVENTS}`;
    return this.http.get(url);
  }
  //#endregion

  //#region  Get all location IATA code in Event Manager
  getFlightIataCode(): any {
    const url = `${settings.UserEndPoint.AirEventManagement.GET_ALL_IATA_CODES}`;
    return this.http.get(url);
  }
  //#endregion

   //#region  Get all IATA code in Event Manager
  //  getAllFlightNumber(): any {
  //   const url = `${settings.UserEndPoint.AirEventManagement.GET_SHIPMENTS_FLIGHT}`;
  //   return this.http.get(url);
  // }
  //#endregion
}